import { UploadRoles } from '../enums';

export const RolesValueFiles: SelectProps[] = [
  { label: 'Inativações', value: UploadRoles.INACTIVATE },
  { label: 'Recargas', value: UploadRoles.RECHARGE },
  {
    label: 'Agendamento de Limite',
    value: UploadRoles.LIMIT_UPDATE_SCHEDULING,
  },
];

export const controlFileColumnsRecharge = [
  'Código de erro',
  'Mensagem',
  'Informações adicionais',
];

export const controlFileColumnsIndividual = ['Código de erro', 'Mensagem', ''];
